import React from 'react';
import {
    TextField,
    Divider,
    Typography,
    Container,
    Box,
    Dialog,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import Button from "@mui/material/Button";




const useStyles = makeStyles(() => ({
    root: {
        width: '350px',
    },
    TypoHeader: {
        margin: '8px 8px 8px 0px',
        wordWrap: 'break-word',
    },
    Typobody: {
        fontSize: '16px',
        lineHeight: '24px',
        wordWrap: 'break-word',
        marginBottom: '20px'
    },
    Container: {
        margin: '10px',
        padding: '10px',
        height: '100%',
        overflowX: 'hidden',
    },
}));

const StyledDialog = withStyles({
    root: {
        '& .MuiDialog-paper': {
            width: '450px',
            overflow: 'hidden',
        },
        '& .MuiButton-containedError': {
            color: '#fff',
            backgroundColor: '#ca3c3d',
        },
        '& .Mui-disabled':{
            color: '#fff',
            backgroundColor: '#EFC5C5',
        }
    },
})(Dialog);



export const DeleteConfirmModal: React.FC<{
    open: boolean;
    onClose: Function;
    name: string;
    handleDelete: Function;
    navigateFn: Function;
}> = (props) => {
    const { onClose, open,  name, handleDelete  } = props;
    const classes = useStyles();
    const [ textValue, setTextValue] = React.useState<string>('');

    const handleClose = (): void => {
        setTextValue('');
        onClose();
    };

    const handleChange = (e: any): void => {
        setTextValue(e.target.value);
    }

    const onDelete = (): void => {
         handleDelete();
    }


    return (
        <StyledDialog onClose={(event: any,reason: string): void => {
            if (reason !== 'backdropClick') {
                handleClose();
            }
        }} aria-labelledby="simple-dialog-title" open={open}>

         <Container className={classes.Container}>
               <Box>
                    <Typography variant="h6" className={classes.TypoHeader}>
                        Delete {name}?
                    </Typography>
                    <Typography variant="body1" className={classes.Typobody}>
                       {name}&nbsp;and its data will be deleted forever. Type <b>&apos;delete&apos;</b>
                       &nbsp;in the text box below and then select the &apos;Delete&apos; button
                    </Typography>
               </Box>
                    <Box >
                                <TextField
                                    inputProps={{ 'data-testid': 'delete-confirm', maxLength: 100 }}
                                    style = {{ width: '95%'}}
                                    helperText="Type 'delete' to continue deleting this device"
                                    variant="filled"
                                    id="delete"
                                    label="Type 'delete'"
                                    value={textValue}
                                    onChange={handleChange}
                                />
                    </Box>
            </Container>
            <Divider />
            <Box>
                <Button
                    style={{ margin: 12 }}
                    variant="outlined"
                    color="primary"
                    data-testid="cancel-device"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    style={{ float: 'right', margin: 12 }}
                    variant="contained"
                    color="error"
                    data-testid="delete-device-confirm-button"
                    disabled = { textValue.toLowerCase() === 'delete' ? false : true}
                    onClick = {onDelete}
                >
                    Delete
                </Button>
            </Box>
        </StyledDialog>

    );
};
